query GetLeadCardFields($stagesetId: String!) {
    leadCardFields(stagesetId: $stagesetId) {
        fieldId
        isRequired
        isRemoveable
        isBoardable
    }
}
